module.exports = __webpack_public_path__ + "img/thumb02_l.e2fcecb1.jpg";